import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/index')), 'home')
    },
    //红包雨
    {
      path: '/redRain',
      name: 'redRain',
      component: resolve => require.ensure([], () => resolve(require('@/public/redRain/index')), 'redRain')
    },

    //九宫格 -- 运行
    {
      path: '/showActivity',
      name: 'showActivity',
      component: resolve => require.ensure([], () => resolve(require('@/public/showActivity/index')), 'showActivity')
    },

    //转盘
    {
      path: '/bigWheel',
      name: 'bigWheel',
      component: resolve => require.ensure([], () => resolve(require('@/public/bigWheel/index')), 'bigWheel')
    },

    //砸金蛋
    {
      path: '/smashGolden',
      name: 'smashGolden',
      component: resolve => require.ensure([], () => resolve(require('@/public/smashGolden/index')), 'smashGolden')
    },

    //每周活动
    {
      path: '/weekActivity',
      name: 'weekActivity',
      component: resolve => require.ensure([], () => resolve(require('@/public/weekActivity/index')), 'weekActivity')
    },

    //直播
    {
      path: '/liveBroadcast',
      name: 'liveBroadcast',
      component: resolve => require.ensure([], () => resolve(require('@/public/liveBroadcast/index')), 'liveBroadcast')
    },

    //投票
    {
      path: '/voteActivity',
      name: 'voteActivity',
      component: resolve => require.ensure([], () => resolve(require('@/public/voteActivity/index')), 'vote')
    },

    // 可视化车位
    {
      path: '/visualPark',
      name: 'visualPark',
      component: resolve => require.ensure([], () => resolve(require('@/public/visualPark/index')), 'visualPark')
    },

    {
      path: '/annualLive',
      name: 'annualLive',
      component: resolve => require.ensure([], () => resolve(require('@/public/annualLive/index')), 'annualLive'),
      meta: {
        keepAlive: false
      }
    },

    // {
    //   path: "/spaceList",
    //   name: "spaceList",
    //   component: resolve =>
    //     require.ensure(
    //       [],
    //       () => resolve(require("@/public/spaceList/index")),
    //       "spaceList"
    //     )
    // },
    // {
    //   path: "/details",
    //   name: "details",
    //   component: resolve =>
    //     require.ensure(
    //       [],
    //       () => resolve(require("@/public/spaceList/details")),
    //       "details"
    //     )
    // },

    //测试
    // {
    //   path: "/test",
    //   name: "test",
    //   component: resolve =>
    //     require.ensure([], () => resolve(require("@/public/test/test")), "test")
    // },
    {
      path: '/signUp',
      name: 'signUp',
      component: resolve => require.ensure([], () => resolve(require('@/public/spaceList/signUp')), 'signUp')
    },
    // 参数丢失跳转页面
    {
      path: '/whiteFound',
      name: 'whiteFound',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/whiteFound')), 'whiteFound')
    }
  ]
});

router.beforeEach((to, from, next) => {
  // if (to.matched.length === 0) {
  //   next("/");
  // } else {
  //   next();
  // }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js